export const GuidelineCitationBadgeTestIds = {
  BADGE: 'guideline-citation-badge',
  PENDING: 'guideline-citation-badge.pending',
  UNAVAILABLE: 'guideline-citation-badge.unavailable',
};
